import React, { useState, useEffect } from 'react';
import { X, Plus, Trash2 } from 'lucide-react';
import api from '../services/api';
import toast from 'react-hot-toast';

const UserManagement = ({ onClose }) => {
  const [emails, setEmails] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadEmails();
  }, []);

  const loadEmails = async () => {
    try {
      const response = await api.get('/authorized-emails');
      setEmails(response.data.emails);
    } catch (error) {
      toast.error('Failed to load authorized emails');
      console.error('Error loading emails:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddEmail = async (e) => {
    e.preventDefault();
    if (!newEmail.trim()) return;

    try {
      await api.post('/authorized-emails', { email: newEmail.trim() });
      toast.success('Email added successfully');
      setNewEmail('');
      loadEmails();
    } catch (error) {
      toast.error('Failed to add email');
      console.error('Error adding email:', error);
    }
  };

  const handleRemoveEmail = async (email) => {
    if (!window.confirm(`Remove ${email} from authorized users?`)) return;

    try {
      await api.delete(`/authorized-emails/${encodeURIComponent(email)}`);
      toast.success('Email removed successfully');
      loadEmails();
    } catch (error) {
      toast.error('Failed to remove email');
      console.error('Error removing email:', error);
    }
  };

  if (loading) {
    return (
      <div className="modal-overlay">
        <div className="modal">
          <div className="modal-header">
            <h2>User Management</h2>
            <button className="close-btn" onClick={onClose}>
              <X size={20} />
            </button>
          </div>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: '500px' }}>
        <div className="modal-header">
          <h2>User Management</h2>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div style={{ padding: '20px' }}>
          <form onSubmit={handleAddEmail} style={{ marginBottom: '20px' }}>
            <div className="form-group">
              <label>Add Authorized Email</label>
              <div style={{ display: 'flex', gap: '10px' }}>
                <input
                  type="email"
                  className="form-control"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder="Enter email address"
                  required
                />
                <button type="submit" className="btn">
                  <Plus size={16} />
                </button>
              </div>
            </div>
          </form>

          <div>
            <h3 style={{ marginBottom: '15px', fontSize: '16px' }}>Authorized Users</h3>
            {emails.length === 0 ? (
              <p style={{ color: '#666', textAlign: 'center' }}>No authorized emails found</p>
            ) : (
              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {emails.map((email, index) => (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      marginBottom: '5px',
                      backgroundColor: email === 'san.eriksen@gmail.com' ? '#f8f9fa' : 'white'
                    }}
                  >
                    <span>
                      {email}
                      {email === 'san.eriksen@gmail.com' && (
                        <span style={{ color: '#666', fontSize: '12px', marginLeft: '10px' }}>
                          (Admin)
                        </span>
                      )}
                    </span>
                    {email !== 'san.eriksen@gmail.com' && (
                      <button
                        className="btn btn-secondary"
                        onClick={() => handleRemoveEmail(email)}
                        style={{ padding: '4px 8px', fontSize: '12px' }}
                      >
                        <Trash2 size={14} />
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserManagement;